module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/ko_6-f3fd10ef6f3fb8812a51ead7226d8be3.jpg";